<template>
  <div class="table-responsive">
    <!-------------------- Tabla de Resultados -------------------->
    <table class="table table-hover">
      <thead>
        <tr>
          <th>#</th>
          <th>Tienda origen</th>
          <th>Tienda destino</th>
          <th>Usuario</th>
          <th>Fecha</th>
          <th>Fecha Ultima Edición</th>
          <th class="text-center">Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="current in dataTabla"
          v-bind:key="current.id"
          @click="rowClick(current)"
        >
          <td>{{ current.numero }}</td>
          <td>{{ current.tienda_origen_obj.nombre }}</td>
          <td>{{ current.tienda_destino_obj.nombre }}</td>
          <td>
            <UsuarioEnTablaComponent :current="current.usuario" />
          </td>
          <td>{{ current.fecha_creacion | moment('DD/MM/YYYY h:mm:ss a') }}</td>
          <td>
            <timeago
              :title="current.fecha_creacion"
              :datetime="current.fecha_creacion"
            ></timeago>
          </td>
          <td class="text-center">
            <div
              data-title="Activo"
              data-toggle="tooltip"
              v-html="current.estado_str"
            ></div>
          </td>
          <td class="text-center"></td>
        </tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";

export default {
  components: {
    UsuarioEnTablaComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: [],
    };
  },
  props: ["dataTabla"],
  computed: {
    ...mapGetters({}),
  },
  mounted() {
    this.$store.dispatch("reqtraslado/fetch");
  },
  methods: {
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "wms-tareas-manuales-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "wms-tareas-manuales-editar",
          params: { id: current.id },
        });
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.$store.dispatch("reqtraslado/fetch", {
        page: page,
        "filter[search]": this.$data.searchtext,
      });
    },
  },
};
</script>
